import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, TextField, Typography } from "@mui/material";
import { route } from "preact-router";

export default function DeleteUserDialog({ state, onClose }) {
	const [form, setForm] = useState({ confirm: "" });
	const [step, setStep] = useState(0);
	const [disabled, setDisabled] = useState(true);
	const handleClose = () => {
		onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		console.log(form.confirm, form.confirm === "supprimer " + state.name);
		setDisabled(!(form.confirm === "me désinscrire"));
	}, [form]);
	const handleSubmitDeleteUser = () => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/73d557cb98d44ecc81f659a80c2c6e64", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setStep(1);
						//route("/newdealv/" + res.id + "/1");
						// //window.location.replace("/newdealv/" + res.id+"/0");
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="optout-user-dialog" open={state.open} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Suppression de votre compte
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				{step === 0 && <div>
					<Typography variant="h5" gutterBottom>
						Vous souhaitez vous désinscrire ?
					</Typography>
					<Typography variant="body1" gutterBottom>
						Pour vous désinscrire, merci d'écrire la phrase "me désinscrire" en toutes lettres dans le champ ci-dessous
					</Typography>
					<div>
						<TextField
							id="confirm"
							name="confirm"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="me désinscrire"
							fullWidth
							margin="dense"
							size="small"
							value={form.confirm}
							onChange={handleChange}
						/>
					</div>
				</div>}
				{step === 1 && <div>
					<Typography variant="h5" gutterBottom>
						Votre demande de désinscription a bien été prise en compte
					</Typography>
					<Typography variant="body1" gutterBottom>
						Un collaborateur Bkeys va prendre contact avec vous au plus vite pour vous confirmer la désinscription
					</Typography>

				</div>}

			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={onClose}>
					{step === 0 ? "Annuler" : "Fermer"}
				</Button>
				{step === 0 && <Button
					variant="contained"
					onClick={handleSubmitDeleteUser}
					//style="margin: 10px;"
					disabled={disabled}
				>
					Me désinscrire
				</Button>}
			</DialogActions>
		</Dialog>
	);
}
